define([
    './_site',
    './window',
    './form',
    './field'
], function(
    Site,
    Wdw,
    Form,
    Field
) {
    var _self;
    // console.log('menu');

    // obj
    _self = {
        toggleLoading: function (flag) {
            var $cartModal = $('#cart-modal'),
                $checkoutModal = $('#checkout-modal');

            if (flag) {
                $cartModal.addClass('cart-modal--loading');
                $checkoutModal.addClass('checkout-modal--loading');
            } else {
                $cartModal.removeClass('cart-modal--loading');
                $checkoutModal.removeClass('checkout-modal--loading');
            }
        },
        isCartLoading: function () {
            var $cartModal = $('#cart-modal');

            // prevent multiple clicks
            if ($cartModal.hasClass('cart-modal--loading')) {
                return true;
            }

            return false;
        },
        isCartActive: function () {
            return $('body').hasClass('cart-active');
        },
        confirmRSVP: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('confirm-rsvp-action'),
                data = Form.cycleBlocks($form),
                flag = false;

            // prevent multiple clicks
            if (_self.isCartLoading()) {
                return false;
            }

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    if (response.status) {
                        _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        updateGuests: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.parent().closest('.form').data('update-guests-action'),
                data = Form.cycleBlocks($form),
                flag = false;

            console.log(data);

            if (Site.updateGuests) {
                console.log('Aborting old request');
                Site.updateGuests.abort();
            }

            // send data
            Site.updateGuests = $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);

                    delete Site.updateGuests;
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        updateCartQuantity: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.parent().closest('.form').data('update-item-action'),
                data = Form.cycleBlocks($form),
                flag = false;

            console.log(data);

            if (Site.updateCartQuantity) {
                console.log('Aborting old request');
                Site.updateCartQuantity.abort();
            }

            // send data
            Site.updateCartQuantity = $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);

                    delete Site.updateCartQuantity;
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        stepBack: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('step-back-action'),
                data = Form.cycleBlocks($form),
                flag = false;

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        stepForward: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action'),
                data = Form.cycleBlocks($form),
                flag = false;

            console.log(data);

            // validation errors
            if (!Form.checkFields($form, true)) {
                return false;
            }

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        createNewAccount: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action'),
                data = Form.cycleBlocks($form),
                flag = false,
                // extra
                address = {
                    // address: $submit.data('address')
                    address: $('#delivery_address').data('address')
                };

            // validation errors
            if (!Form.checkFields($form, true)) {
                return false;
            }

            // address
            $.extend(data, address);

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    _self.toggleLoading(true);
                },
                success: function (response) {

                    _self.updateView(response);

                    if (response.status) {
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        sendFeedback: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action'),
                data = Form.cycleBlocks($form),
                flag = false;

            console.log(data);

            // validation errors
            if (!Form.checkFields($form)) {
                return false;
            }

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        if (response.url) {
                            window.location.href = response.url;
                            return;
                        }
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        toggle: function() {
            $('body').removeClass('header-active menu-active submenu-active');
            $('body').toggleClass('cart-active');

            if ($('#membership-ad').is(':visible')) {
                $('body').toggleClass('membership-ad-active');
            }

            if ($('#cart').data('confirmed')) {
                $('body').toggleClass('checkout-active');
            } else {
                $('body').removeClass('checkout-active membership-ad-active');
            }
        },
        toggleCartModal: function($el) {
            var $cartModal = $('#cart-modal'),
                $container = $cartModal.find('.cart-modal__content');

            $cartModal.toggleClass('cart-modal--active');
            $container.slideToggle(200);
        },
        remove: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.parent().closest('.form').data('remove-action'),
                data = Form.cycleBlocks($form),
                flag = false;

            // prevent multiple clicks
            if (_self.isCartLoading()) {
                return false;
            }

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        add: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.attr('action'),
                data = Form.cycleBlocks($form),
                submitClass = 'form__submit',
                flag = false;
                // newtab = window.open( '', '_blank' );

            // validation errors
            if (!Form.checkFields($form, true)) {
                return false;
            }

            // prevent multiple clicks
            if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
                return false;
            }

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    _self.toggleLoading(true);
                    _self.toggle();
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        if (response.url) {
                            // console.log(newtab);
                            // newtab.location = response.url;
                            // window.open(response.url, '_blank');
                            window.location.href = response.url;
                        }
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        selectTab: function ($el) {
            var $submit = $el,
                $tabs = $submit.closest('ul'),
                $target = $tabs.children('input[type="hidden"]'),
                value = $submit.data('tab-value');

            $target.val(value);
        },
        updateStupidButton: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('update-button'),
                data = Form.cycleBlocks($form),
                flag = false,
                // custom
                $button = $form.find('[type=submit]');

            function toggleLoader(flag) {
                if (flag) {
                    $button.addClass('button--disabled');
                } else {
                    $button.removeClass('button--disabled');
                }
            }

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    toggleLoader(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        if (response.button) {
                            $button.replaceWith(response.button);
                        }
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    toggleLoader(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    toggleLoader(false);
                }
            });
        },
        // checkout related
        updateView: function (data) {
            var $cart = $('#cart'),
                $donation = $('#donation'),
                $payment = $('#payment'),
                $login = $('#checkout-login'),
                $cartModal = $('#cart-modal'),
                $checkoutModal = $('#checkout-modal'),
                $membershipAd = $('#membership-ad'),
                $inputs;

            // cart
            if (typeof(data.cart) !== 'undefined' && data.cart) {
                $cart.replaceWith(data.cart);
            }
            // delivery
            if (typeof(data.donation) !== 'undefined' && data.donation) {
                $delivery.replaceWith(data.delivery);
            }
            // payment
            if (typeof(data.payment) !== 'undefined' && data.payment) {
                $payment.replaceWith(data.payment);
            }
            // login
            if (typeof(data.login) !== 'undefined' && data.login) {
                $login.replaceWith(data.login);
            }

            // membership-ad
            if (typeof(data.membershipAd) !== 'undefined') {
                $membershipAd.find('.membership-ad__container').html(data.membershipAd);

                // display checkout
                if (data.membershipAd) {
                    $membershipAd.show();
                    $('body').addClass('membership-ad-active');
                } else {
                    $('body').removeClass('membership-ad-active').delay(300).queue(function () {
                        $membershipAd.hide();
                        $membershipAd.dequeue();
                    });
                }
            }

            // checkout-modal
            if (typeof(data.checkoutModal) !== 'undefined') {
                $checkoutModal.find('.checkout-modal__container').html(data.checkoutModal);

                // display checkout
                if (data.checkoutModal) {
                    $('body').addClass('checkout-active');
                } else {
                    $('body').removeClass('checkout-active membership-ad-active');
                }

                Field.Address.create($checkoutModal);
            }

            // cart-modal
            if (typeof(data.cartModal) !== 'undefined') {
                $cartModal.find('.cart-modal__content').css('display', '').html(data.cartModal);

                // mobile test
                if (!data.checkoutModal) {
                    $cartModal.removeClass('cart-modal--active');
                }

                // display checkout
                if (data.cartModal) {
                    $('body').addClass('cart-active');
                } else {
                    $('body').removeClass('cart-active');
                }
            }

            // render recaptcha
            _self.renderGoogleCaptcha($checkoutModal.find('.g-recaptcha'));

            // trigger input values
            $inputs = $checkoutModal.find('input, select, textarea');
            $inputs.add($cartModal.find('input, select, textarea'));
            Field.testValue($inputs);
        },
        renderGoogleCaptcha: function($recaptcha) {
            if(grecaptcha !== undefined && $recaptcha.length) {
                $recaptcha.each(function() {
                    var $el = $(this),
                        siteKey = $el.data('sitekey');

                    if($el.children().length <= 0) {
                        console.log('Rendering grecaptcha');
                        grecaptcha.render($el[0], {
                            'siteKey': siteKey,
                        });
                    }
                })
            }
        },
        verifyEmail: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action'),
                data = Form.cycleBlocks($form),
                flag = false;

            // validation errors
            if (!Form.checkFields($form, true)) {
                return false;
            }

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    _self.toggleLoading(true);
                },
                success: function (response) {

                    _self.updateView(response);

                    if (response.status) {
                        // _self.updateView(response);

                        if (response.login) {
                            Form.focusFirstField($('#checkout-login'));
                            // Browser.removeFormValidation();
                        }
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        login: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action'),
                data = Form.cycleBlocks($form),
                flag = false;

            // validation errors
            if (!Form.checkFields($form, true)) {
                return false;
            }

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        recoverPassword: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action'),
                data = Form.cycleBlocks($form),
                flag = false;

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    if (response.status) {
                        // create alert
                        Wdw.createAlert(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        showLogin: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                url = $form.data('show-login-action');

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: false,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {

                        // _self.updateView(response);

                        if (response.login) {
                            Form.focusFirstField($('#checkout-login'));
                            // Browser.removeFormValidation();
                        }
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        checkout: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action'),
                data = Form.cycleBlocks($form),
                flag = false;

            console.log(data);

            // // validation errors
            if (!Form.checkFields($form, true)) {
                return false;
            }

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    _self.toggleLoading(true);
                },
                success: function (response) {
                    console.log(response);

                    _self.updateView(response);

                    if (response.status) {
                        if (response.url) {
                            window.location.href = response.url;
                        }
                        // _self.updateView(response);
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    _self.toggleLoading(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    _self.toggleLoading(false);
                }
            });
        },
        showFullAddress: function ($el) {
            var $form = $el.closest('.form') || $el.closest('form');

            $form.find('.address-full-form').removeClass('hidden');
            $form.find('.address-mini-form').addClass('hidden');
        }
    };


    // -------------------
    // BINDS
    // -------------------

    $('.select-tickets').on('change.cart', function (event) {
        _self.updateStupidButton($(this));
    });

    // ---------------- toggle menu
    $('#wrapper').on('click.cart', '[data-toggle-cart]', function(event) {
        event.preventDefault();
        _self.toggle();
    });

    // ---------------- add item to cart
    $('#wrapper').on('click.cart', '[data-add-cart]', function(event) {
        event.preventDefault();
        _self.add($(this));
    });

    // ---------------- toggle menu
    $('#cart-modal').on('click.cart', '[data-toggle-cart-modal]', function(event) {
        event.preventDefault();
        _self.toggleCartModal($(this));
    });

    // ---------------- toggle loading
    $('#cart-modal').on('loading', function (event, display) {
        _self.toggleLoading(display);
    });

    // ---------------- remove item from cart
    $('#cart-modal').on('click.cart', '[data-remove-cart]', function(event) {
        event.preventDefault();
        _self.remove($(this));
    });

    // ---------------- confirm rsvp
    $('#cart-modal').on('click.cart', '[data-confirm-rsvp]', function(event) {
        event.preventDefault();
        _self.confirmRSVP($(this));
    });

    // ---------------- update cart quantity
    $('#cart-modal').on('change.cart', '.field--qty--item input', function(event) {
        event.preventDefault();
        _self.updateCartQuantity($(this));
    });

    // ---------------- update guests
    $('#cart-modal').on('change.cart', '.field--qty--guest input', function(event) {
        event.preventDefault();
        _self.updateGuests($(this));
    });

    // ---------------- create new account
    $('#checkout-modal').on('click.cart', '[data-new-account]', function(event) {
        event.preventDefault();
        _self.createNewAccount($(this));
    });

    // ---------------- create new account
    $('#checkout-modal').on('click.cart', '[data-placeholder-action]', function(event) {
        event.preventDefault();
        _self.placeholderFunction($(this));
    });

    // ---------------- step back
    $('#checkout-modal').on('click.cart', '[data-step-back]', function(event) {
        event.preventDefault();
        _self.stepBack($(this));
    });

    // ---------------- update guests info
    $('#checkout-modal').on('click.cart', '[data-step-forward]', function(event) {
        event.preventDefault();
        _self.stepForward($(this));
    });

    // ---------------- checkout
    $('#checkout-modal').on('click.cart', '[data-process-checkout]', function(event) {
        event.preventDefault();
        _self.checkout($(this));
    });

    // ---------------- select tab
    $('#checkout-modal').on('click.cart', '[data-tab-value]', function(event) {
        event.preventDefault();
        _self.selectTab($(this));
    });

    // ---------------- send feeback
    $('#checkout-modal').on('click.cart', '[data-send-feedback]', function(event) {
        event.preventDefault();
        _self.sendFeedback($(this));
    });

    // ---------------- show full address form
    $('#checkout-modal, #content').on('click.cart', '[data-show-fullform]', function (event) {
        event.preventDefault();
        _self.showFullAddress($(this));
    });




    // ---------------- update view
    $('#wrapper').on('updateView', function (event, data) {
        _self.updateView(data);
    });

    // ---------------- verify email
    $('#cart-modal').on('click', '[data-verify-email]', function(event) {
        event.preventDefault();
        _self.verifyEmail($(this));
    });

    // ---------------- login
    $('#cart-modal').on('click', '[data-login]', function(event) {
        event.preventDefault();
        _self.login($(this));
    });

    // ---------------- recover password
    $('#cart-modal').on('click', '[data-recover-password]', function(event) {
        event.preventDefault();
        _self.recoverPassword($(this));
    });

    // ---------------- show login
    $('#cart-modal').on('click', '[data-show-login]', function(event) {
        event.preventDefault();
        _self.showLogin($(this));
    });

    return _self;
});
